import { RequestPromise, rawPost } from '@portal-packages/api';

import { API_CLIENTS } from '@constants/api';

import { GENERATE_ACCESS_TOKEN } from '../constants';
import { AccessToken } from '../types';
import { getLocalRefreshToken } from '../utils/refresh-token';

export const generateAccessToken = (
  username: string,
  password: string,
  recaptchaToken: string
): RequestPromise<AccessToken> => {
  const data = { username, password };

  return rawPost<AccessToken, URLSearchParams>({
    entity: GENERATE_ACCESS_TOKEN,
    client: API_CLIENTS.APP,
    url: '/auth/token',
    data: new URLSearchParams(data),
    config: {
      params: {
        recaptchaToken,
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      withCredentials: false,
    },
  });
};

export const refreshAccessToken = (): RequestPromise<AccessToken> => {
  const data = {
    grant_type: 'refresh_token',
    refresh_token: getLocalRefreshToken(),
  };

  return rawPost<AccessToken, URLSearchParams>({
    entity: GENERATE_ACCESS_TOKEN,
    client: API_CLIENTS.APP,
    url: '/auth/token',
    data: new URLSearchParams(data),
    config: {
      // The axios interceptor will try to refresh the token
      // for all requests that fail by 401, this avoidRefreshToken
      // is required so it doesn't try with this request, which would
      // cause a infinite loop.
      // @ts-ignore
      avoidRefreshToken: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      withCredentials: false,
    },
  });
};
